//@ts-ignore
import * as AOS from "aos";
//@ts-ignore
import * as Rellax from "rellax";
//@ts-ignore
import * as scrollama from "scrollama";
//@ts-ignore
import gsap from "gsap";

export namespace ScrollEffects {
	let initParallax = () => {
		if (window.matchMedia('(max-width: 767px)').matches) {
			return;
		}

		if($('.rellax').length) {
			new (Rellax as any)('.rellax', {
				center: true
			});
		}

		let handleScrollCallback = (action, callback) => {
			// callback = { element: DOMElement, index: number, direction: string }
			let $el = $(callback.element);
			let scrollActions = (action === 'enter') ? $el.data('scroll-enter') : $el.data('scroll-exit');

			if (!scrollActions) {
				return;
			}

			if (typeof(scrollActions) === 'string') {
				scrollActions = [{
					action: scrollActions,
					target: $el.data('target'),
					delay: $el.data('delay') || 0
				}];
			}

			for (var i = 0; i < scrollActions.length; i++) {
				let nextSequence:any = scrollActions[i];
				let nextAction:any = nextSequence.action;
				let $nextTarget:any = $el.find(nextSequence.target) || $el;
				let delay:any = nextSequence.delay || 0;

				switch (nextAction) {
					case 'applyClass':
					case 'apply-class':
					case 'add_class':
						gsap.delayedCall(delay, function () {
							let scrollClass = nextSequence.class || $el.data('scroll-class');
							$nextTarget.addClass(scrollClass);
						});
						break;
					case 'removeClass':
					case 'remove-class':
					case 'remove_class':
						gsap.delayedCall(delay, function () {
							let scrollClass = nextSequence.class || $el.data('scroll-class');
							$nextTarget.removeClass(scrollClass);
						});
						break;
					case 'playVideo':
					case 'play_video':
						($nextTarget.get(0) as any).play();
						break;
					case 'pauseVideo':
					case 'pause_video':
						($nextTarget.get(0) as any).pause();
						break;
				}
			}
		}

		function handleScrollEnter(callback) {
			handleScrollCallback('enter', callback);
		}

		function handleScrollExit(callback) {
			handleScrollCallback('exit', callback);
		}

		let scroller = scrollama();

		if ( $('.step').length ) {
			scroller.setup({
				step: '.step',
			}).onStepEnter(handleScrollEnter).onStepExit(handleScrollExit);
		}
	}

	let initTriggeredInteractions = () => {
		$('[data-trigger]').on('click', function (e) {
			e.preventDefault();

			var $this = $(this);
			var action = $this.data('trigger');
			var $target = $($this.data('target'));

			switch (action) {
				case 'play-video':
				case 'playVideo':
					($target.get(0) as any).play();
					break;
			}
		});
	};

	export const init = () => {
		AOS.init({startEvent: 'load'});
		initParallax();
		initTriggeredInteractions();
	}
}
